/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Generate_SubtitleInputs */

const en_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job and resume to generate a tailored cover letter.`)
};

const de_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle eine Stelle und einen Lebenslauf, um ein maßgeschneidertes Anschreiben zu generieren.`)
};

const fr_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionne un emploi et un CV pour générer une lettre de motivation sur mesure.`)
};

const es_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un empleo y un currículum para generar una carta de presentación personalizada.`)
};

const it_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un lavoro e un curriculum per generare una lettera di presentazione personalizzata.`)
};

const nl_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer een baan en CV om een op maat gemaakte motivatiebrief te genereren.`)
};

const pl_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz ofertę pracy i CV, aby wygenerować spersonalizowany list motywacyjny.`)
};

const fi_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse työpaikka ja ansioluettelo luodaksesi räätälöidyn saatekirjeen.`)
};

const da_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et job og CV for at generere et skræddersyet ansøgningsbrev.`)
};

const sv_cover_letters_generate_subtitle = /** @type {(inputs: Cover_Letters_Generate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett jobb och CV för att generera ett skräddarsytt personligt brev.`)
};

/**
* | output |
* | --- |
* | "Select a job and resume to generate a tailored cover letter." |
*
* @param {Cover_Letters_Generate_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_generate_subtitle = /** @type {((inputs?: Cover_Letters_Generate_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Generate_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_generate_subtitle(inputs)
	if (locale === "fr") return fr_cover_letters_generate_subtitle(inputs)
	if (locale === "es") return es_cover_letters_generate_subtitle(inputs)
	if (locale === "it") return it_cover_letters_generate_subtitle(inputs)
	if (locale === "nl") return nl_cover_letters_generate_subtitle(inputs)
	if (locale === "pl") return pl_cover_letters_generate_subtitle(inputs)
	if (locale === "fi") return fi_cover_letters_generate_subtitle(inputs)
	if (locale === "da") return da_cover_letters_generate_subtitle(inputs)
	if (locale === "sv") return sv_cover_letters_generate_subtitle(inputs)
	return en_cover_letters_generate_subtitle(inputs)
});